<span class="mo-selector-option-container" [class]="containerClass">
  <tc-master-operator-connect-indicator
    *ngIf="!hideConnect"
    [instance]="instance"
  ></tc-master-operator-connect-indicator>
  <span class="instance-pill">
    {{ label }}
  </span>
</span>
